import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import scmp, { FlexColContainer } from 'components/StyledComp';
import ChangeHistoriesDialog from './ChangeHistoriesDialog';

const propTypes = {
  table: PropTypes.string.isRequired,
  rowId: PropTypes.number,
  patientId: PropTypes.number,
  caregiverId: PropTypes.number,

  title: PropTypes.string,
};

const defaultProps = {
  title: 'Change History',
};

@autobind
class ChangeHistoriesButton extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      isChangeHistoriesDialogVisible: false,
    };
  }

  onShowDialogClick() {
    this.setState({
      isChangeHistoriesDialogVisible: true,
    });
  }

  renderContent() {
    const { table, rowId, patientId, caregiverId, title, ...layoutProps } = this.props;
    const { isChangeHistoriesDialogVisible } = this.state;

    return (
      <FlexColContainer
        {...layoutProps}
        alignItems="center"
      >
        <scmp.Span
          width="wrap_content"
          height="32px"
          padding="0 6px"
          backgroundColor="#e1e5ec"
          backgroundColorHover="#c2cad8"
          border="1 solid #e1e5ec"
          borderHover="1 solid #e1e5ec"
          cursor="pointer"
          textAlign="center"
          color="#666666"
          fontSize="12px"
          fontWeight="600"
          lineHeight="32px"
          onClick={this.onShowDialogClick}
        >
          {title}
        </scmp.Span>

        <ChangeHistoriesDialog
          width="80%"
          height="wrap_content"
          table={table}
          rowId={rowId}
          patientId={patientId}
          caregiverId={caregiverId}
          isVisible={isChangeHistoriesDialogVisible}
          onVisibleChange={(visible) => this.setState({ isChangeHistoriesDialogVisible: visible })}
        />
      </FlexColContainer>
    );
  }
}

ChangeHistoriesButton.propTypes = propTypes;
ChangeHistoriesButton.defaultProps = defaultProps;

export default ChangeHistoriesButton;
